/**
 * DocumentsEmptyState Component
 *
 * The no-rows overlay of the Documents, Labs, and Forms tables: the page's
 * icon, one line of text, the page's existing action if it has one, and a slot
 * for the guide link under it. Slots that render nothing take no space, so the
 * overlay keeps its shape while the guide link is absent.
 */

import { Stack, Typography } from '@mui/material';

import type { DocumentsEmptyStateProps } from './DocumentsEmptyState.types';

export function DocumentsEmptyState({
  icon: Icon,
  message,
  primaryAction,
  secondaryAction,
}: DocumentsEmptyStateProps) {
  return (
    <Stack
      spacing={1}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
        py: 4,
      }}
    >
      <Icon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
      <Typography color="text.secondary">{message}</Typography>
      {primaryAction}
      {secondaryAction}
    </Stack>
  );
}
